// extracted by mini-css-extract-plugin
export default {"base":"Icon_base__29FPp"};